import React, { Component } from "react"
import { BrowserRouter } from "react-router-dom"
import RouteManagement from "./RouteManagement"
import "./tailwind-generated.css"
import "animate.css"

export default class App extends Component {
  render() {
    return (
      <BrowserRouter>
        <RouteManagement />
      </BrowserRouter>
    )
  }
}
